import * as React from "react";
import { connect } from "react-redux";

import {
  Container as ContainerComponent,
  ContainerProps,
} from "../../components/Container/Container";

class Container extends React.Component<ContainerProps> {
  render() {
    return <ContainerComponent {...this.props} />;
  }
}

export default connect(null, {})(Container);
